import React, { useMemo, useEffect, useState } from "react";
import { useNavigate, useParams } from "react-router-dom";
import { GetRosterById, UpdateRoster } from "adminApi/DutyRosterApi/RosterApi";
import { validateForm } from "utils/validation";
import { RosterRules } from "validation/ValidationRules";
import Spinner from "Common/Globle/Spinner";
import EditRosterForm from "./Componates/EditRosterForm";
import fieldsJson from "../json/RosterFields.json";
import useFormSubmit from "Hooks/useFormSubmit";

const EditRoster = () => {
    const { id } = useParams();
    const navigate = useNavigate();
    const [loadingFetch, setLoadingFetch] = useState(true);

    const allFields = useMemo(() => fieldsJson.formFields, []);

    const [values, setValues] = useState({});
    const [errors, setErrors] = useState({});

    useEffect(() => {
        const fetchRoster = async () => {
            try {
                const res = await GetRosterById(id);
                if (res?.data?.success && res?.data?.data) {
                    // Pre-populate values
                    const rosterData = res.data.data;
                    const initial = allFields.reduce((acc, field) => {
                        acc[field.name] = rosterData[field.name] || "";
                        return acc;
                    }, {});
                    setValues(initial);
                } else {
                    console.error("Failed to load roster data");
                }
            } catch (err) {
                console.error("Error fetching roster", err);
            } finally {
                setLoadingFetch(false);
            }
        };
        if (id) {
            fetchRoster();
        }
    }, [id, allFields]);

    const handleChange = (e, field) => {
        let value = e.target ? e.target.value : e;
        setValues((prev) => ({ ...prev, [field.name]: value }));
        setErrors((prev) => ({ ...prev, [field.name]: null }));
    };

    const { loading: loadingSubmit, handleSubmit } = useFormSubmit(
        async (formValues) => {
            return await UpdateRoster({ id, data: formValues });
        },
        (vals) => {
            const err = validateForm(vals, RosterRules);
            setErrors(err);
            return err;
        },
        () => navigate(-1),
        "Duty Roster Updated successfully!"
    );

    return (
        <>
            {(loadingFetch || loadingSubmit) && <Spinner isSpinner={true} />}
            {!loadingFetch && (
                <EditRosterForm
                    fields={allFields}
                    values={values}
                    errors={errors}
                    handleChange={handleChange}
                    handleSubmit={(e) => handleSubmit(e, values)}
                    loading={loadingSubmit}
                    title="Edit Duty Roster"
                />
            )}
        </>
    );
};

export default EditRoster;
